let contents_all = [
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2007_300.jpg",
        title:"300",
        englishTitle:"300",
        release:[2007,3],
        country:["미국"],
        type:["영화"],
        genre:["액션" , "전쟁" , "드라마" , "판타지"],
        playTime:["1시간 57분"],
        creater:["잭 스나이더","커트 존스태드","마이클 B. 고든","잔니 눈나리","마크 캔턴","버니 골드먼","제프리 실버"],
        synopsis:"BC 480년, 페르시아 국왕 크세르크세스(로드리고 산토로)가 이끄는 대군이 그리스로 진군해온다. 1년 전 복종을 요구하는 페르시아 사자를 우물에 처넣었던 스파르타 국왕 레오니다스(제라드 버틀러)는 그리스 도시국가들과 연합군을 결성하려고 하지만, 신탁은 이를 허락하지 않는다. 그러나 레오니다스는 전쟁에 반대하는 의회에 등을 돌리고 300명의 정예부대와 테르모필레 협곡으로 향한다. 대를 이을 아들이 있는 자만 선발한 레오니다스는 자신이 다시는 왕비 고르고(레나 헤디) 곁으로 돌아오지 못하리라는 사실을 알고 있다.",
        cast:["제라드 버틀러","레나 헤디","도미닉 웨넘","도미닉 웨스트","호드리구 산토루"],
        background:"그리스",
        adaptation:"각색된 역사",
        keyword:["테르모필레 전투","원작이 존재"],
        src:"UrIbxk7idYA"
    },
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2005_rome.jpg",
        title:"로마",
        englishTitle:"ROME",
        release:[2005,8],
        country:["미국"],
        type:["TV 프로그램"],
        genre:["액션" , "전쟁" , "드라마","로맨스"],
        playTime:["22부작"],
        creater:["BBC"],
        synopsis:"더할 나위 없는 번영을 누리는 로마 제국. 이 로마의 세력을 양분하는 폼페이우스우스와 시저는 막역한 벗이다. 하지만 지난 8년간, 갈리아 정복 전쟁을 떠난 시저가 전리품과 승전보를 전하며 백성들 사이 인기가 치솟으면서, 평민의 편에 선 시저를 견제하는 귀족파 원로원의 시선이 곱지 않다. 이들은 폼페이우스에게 불법 정복 전쟁을 벌이고 일부 원로원 의원에게 뇌물을 준 시저를 로마로 송환해 처벌하라고 종용하지만 폼페이우스는 친구를 배신할 수 없다며 단호하게 거절한다. 한편, 시저의 13군단에 속한 백부장 보레누스는 항명과 반항을 일삼는 병사 풀로를 감옥에서 꺼내 특별 임무를 수행한다. 바로 도난당한 시저의 상징인 독수리상을 찾아오는 것.",
        cast:["케빈 맥키드", "레이 스티븐슨", "키어런 하인즈", "케네스 크랜햄", "린제이 던칸"],
        background:"고대 로마",
        adaptation:"실제 역사에 가까운",
        keyword:["고대 로마","고증이 좋은"],
        src:"Qcz189fJt0U"
    },
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2004_alexander.jpg",
        title:"알렉산더",
        englishTitle:"Alexander",
        release:[2004,11],
        country:["미국"],
        type:["영화"],
        genre:["액션" , "전쟁" , "드라마","로맨스"],
        playTime:["2시간 55분"],
        creater:["올리버 스톤","크리스토퍼 카일","래타 칼로그리디스"],
        synopsis:"그토록 원대했던 젊은 그의 꿈을 어떻게 설명할 수 있을까? 역사의 판도를 바꾼 위대한 정복자! 술주정뱅이인 아버지이자 마케도니아의 왕인 필립, 그와 왕비는 서로 저주를 퍼부으며 증오한다. 그 사이에서 위대한 영웅들의 이야기를 들으며 자란 알렉산더는 세계를 하나의 제국으로 통일하는 원대한 꿈을 꾸며, 20세에 왕위에 오르게 된다. 이후 13년만에 그리스, 페르시아, 인도에 이르는 3개의 대륙을 정복해 대제국을 건설하고, 헬레니즘 문화를 형성한 역사상 가장 위대한 정복자 알렉산더 대왕. 33세 라는 젊은 나이에 생을 마감한 그의 짧지만 화려하고 무모하면서도 용감한 그의 인생이 펼쳐진다.",
        cast:["콜린 패럴","안젤리나 졸리","안소니 홉킨스","자레드 레토","발 킬머"],
        background:"고대 마케도니아",
        adaptation:"실제 역사에 가까운",
        keyword:["알렉산드로스 대왕","고증이 좋은"],
        src:"UrIbxk7idYA"
    },
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2004_troy.jpg",
        title:"트로이",
        englishTitle:"Troy",
        release:[2004,5],
        country:["미국"],
        type:["영화"],
        genre:["액션" , "전쟁" , "드라마","로맨스"],
        playTime:["2시간 43분(극장판)","3시간 16분(디렉터스 컷)"],
        creater:["볼프강 페테르젠","다이애나 래스번", "콜린 윌슨"],
        synopsis:"고대 그리스 시대, 가장 잔인하고 불운한 사랑에 빠지고 만 비련의 두 주인공 트로이의 왕자 파리스와 스파르타의 왕비 헬레네. 사랑에 눈 먼 두 남녀는 트로이로 도주하고, 파리스에게 아내를 빼앗긴 스파르타의 왕 메넬라오스는 미케네의 왕이자 자신의 형인 아가멤논에게 복수를 부탁한다. 아가멤논은 그리스 도시 국가들을 규합해 트로이로부터 헬레네를 되찾기 위한 전쟁을 일으킨다. 그러나 전쟁의 명분은 동생의 복수였지만, 진짜 이유는 모든 도시 국가들을 통합하여 거대한 그리스 제국을 건설하려는 야심이었다.",
        cast:["브래드 피트", "에릭 바나", "올랜도 블룸", "다이앤 크루거","브라이언 콕스", "숀 빈", "브렌던 글리슨", "피터 오툴", "로즈 번"],
        background:"고대 그리스",
        adaptation:"각색된 역사",
        keyword:["트로이 전쟁","원작이 존재"],
        src:"1lRQc-YugZE"
    },
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2004_thepassionofthechrist.jpg",
        title:"패션 오브 크라이스트",
        englishTitle:"The Passion of the Christ",
        release:[2004,5],
        country:["미국"],
        type:["영화"],
        genre:["종교", "드라마"],
        playTime:["2시간 6분"],
        creater:["멜 깁슨","베네딕트 피츠제럴드", "브루스 다비","스티븐 맥케비티"],
        synopsis:"마지막 만찬 후에 겟세마니 동산에 올라간 예수는 그 곳에서 사탄의 유혹을 물리친다. 그러나 그 곳에서 예수 그리스도는 유다에게 배신 당해 체포되어 예루살렘으로 끌려온다. 바리새인들은 예수 그리스도를 신성모독죄로 단죄하고, 재판에서 사형을 선고한다. 팔레스타인의 로마 제독, 빌라도는 바리새인들의 주장을 들으며 그의 앞에 끌려온 예수 그리스도를 어떻게 처리할지 고민한다. 자신이 정치적 위기에 직면해 있음을 깨달은 빌라도는 이 문제를 헤롯왕에게 의논한다. 헤롯왕은 빌라도에게 예수 그리스도를 돌려보낸다. 이에 빌라도가 군중들에게 그리스도와 죄수 바라바 중 누구를 석방할지 결정하도록 하자, 군중들은 바라바에게 자유를 예수 그리스도에게 처형을 주장한다. 로마 병사들로부터 처참하게 채찍질을 당한 그리스도는 빌라도 앞에 다시 끌려오게 된다. 빌라도는 만신창이가 된 예수 그리스도를 군중에게 보이며, ‘이 정도면 충분하지 않은가?’라고 묻지만 피에 굶주린 군중들은 만족하지 못한다. 딜레마에 빠진 빌라도는 군중들이 원하는 대로 처리하도록 부하들에게 명령한다. 그리하여 예수 그리스도는 예루살렘 거리를 지나 골고다 언덕까지 십자가를 메고 가도록 명령을 받는다. 골고다 언덕 위에서 예수 그리스도는 십자가에 못 박히게 되고 그 곳에서 마지막 유혹에 직면한다. 그의 아버지가 그를 버렸을 지도 모른다는 두려움 때문이었다. 하지만 예수 그리스도는 두려움을 극복하고 어머니인 마리아를 바라보며 그녀만이 완전히 이해할 수 있는 마지막 한 마디를 하고 죽는다. “다 이루었도다.”“내 영혼을 아버지 손에 맡기나이다.”...",
        cast:["제임스 카비젤, 모니카 벨루치"],
        background:"예루살렘",
        adaptation:"각색된 역사",
        keyword:["예수","고증이 좋은"],
        src:"8hTEwGTjsNs"
    },
    {
        category:"고대·고전",
        age:"기원전 40세기 - 4세기",
        img:"2000_gladiator.jpg",
        title:"글래디에이터 ",
        englishTitle:"Gladiator",
        release:[2000,5],
        country:["미국"],
        type:["영화"],
        genre:["액션" ,"드라마"],
        playTime:["2시간 35분(극장판)","2시간 50분(확장판)"],
        creater:["리들리 스콧","데이비드 프란조니","존 로건","윌리엄 니콜슨","더글라스 윅","데이비드 프란조니","브란코 루스티그"],
        synopsis:"죽을 날이 머지않은 황제 마르쿠스 아우렐리우스는 막시무스를 총애하여 아들이 아닌 그에게 권력을 넘겨주기로 한다. 황제의 아들 코모두스는 이에 질투와 분노를 느껴 황제를 살해한다. 왕좌를 이어받은 코모두스는 막시무스와 그의 가족을 죽이라고 명령한다. 가족을 모두 잃고 겨우 살아남은 막시무스는 노예로 전락하고, 투기장의 검투사가 된다. 그에게 남은 건 오직 황제 코모두스에 대한 복수 뿐. 검투사로서 매 경기마다 승리로 이끌면서 살아남자 그의 명성은 날로 높아 간다. 그러던 어느 날 오래 전 사랑했던 황제의 누이 루실라를 다시 만나게 되는데...",
        cast:["러셀 크로우","호아킨 피닉스","코니 닐슨"],
        background:"고대 로마",
        adaptation:"각색된 역사",
        keyword:["로마제국"],
        src:"AxQajgTyLcM"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"2018_thegreatbattle.jpg",
        title:"안시성",
        englishTitle:"The Great Battle",
        release:[2018,9],
        country:["한국"],
        type:["영화"],
        genre:["액션"],
        playTime:["2시간 15분"],
        creater:["김광식","구태진","김용선"],
        synopsis:"천하를 손에 넣으려는 당 태종은 수십만 대군을 동원해 고구려의 변방 안시성을 침공한다. 20만 당나라 최강 대군 VS 5천명의 안시성 군사들. 40배의 전력 차이에도 불구하고, 안시성 성주 양만춘과 전사들은 당나라에 맞서 싸우기로 결심하는데.. 동아시아 역사상 가장 위대한 승리를 이끈 안시성 전투가 시작된다!",
        cast:["조인성","남주혁","박성웅"],
        background:"고구려",
        adaptation:"각색된 역사",
        keyword:["삼국시대","안시성 전투"],
        src:"VpWZiscDYuk"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"2009_agora.jpg",
        title:"아고라",
        englishTitle:"Ágora",
        release:[2009,10],
        country:["스페인"],
        type:["영화"],
        genre:["전기"],
        playTime:["2시간 7분"],
        creater:["알레한드로 아메나바르","마테오 힐","페르난도 보바이라","알바로 아우구스틴"],
        synopsis:"로마제국이 최후를 맞이하는 격변의 시기, 신의 이름으로 세상을 지배하려는 야망으로 가득찬 이들은 거대 전쟁을 일으킬 준비를 한다. 미모와 지성을 겸비해 모든 남성들의 선망의 대상이 되었던 세기의 여인, 천재 천문학자 히파티아(레이첼 웨이즈)는 전쟁의 소용돌이 속 오직 진리만을 위해 세상과 맞서 싸운다. 한편, 스승 히파티아를 향한 사랑과 야망 사이에서 갈등하는 오레스테스(오스카 아이삭)는 결국 권력을 선택하고, 신의 이름으로 수많은 사람을 전쟁으로 몰아넣는 주교 시릴은 자신의 길을 방해하는 히파티아를 처단하기 위해 온갖 음모를 계략한다. 노예의 신분으로 히파티아를 사랑했지만, 이룰 수 없는 운명 앞에 신을 택했던 다보스(맥스 밍겔라)는 죽음의 위기에 놓인 히파티아를 위해 마지막 순간 가장 비극적인 사랑의 방식을 선택하는데… 과연, 신의 이름으로 세상을 지배하려는 세력과 그에 맞서는 사람들의 역사를 뒤흔든 전쟁의 끝은 어떻게 될 것인가?",
        cast:["레이철 바이스","맥스 밍겔라","오스카 아이작"],
        background:"이집트",
        adaptation:"각색된 역사",
        keyword:["서로마 멸망","히파티아"],
        src:"iKJ4pbZC0H8"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"2007_beowulf.jpg",
        title:"베오울프",
        englishTitle:"Beowulf",
        release:[2007,11],
        country:["미국"],
        type:["영화"],
        genre:["애니메이션","판타지","액션"],
        playTime:["1시간 55분"],
        creater:["로버트 저메키스","닐 게이먼","로저 애버리 ", "스티브 빙", "잭 랩키", "스티브 스타키","로저 로버츠","마틴 셰퍼"],
        synopsis:"신과 인간, 괴물과 영웅이 공존하는 암흑의 시대. 호르트가르 성 사람들은 밤마다 용사들을 잔인하게 살인하고, 납치해가는 정체불명의 괴물로 인해 고통 받고 있다. 이때 젊은 용사 하나가 바다를 건너 그들을 구하기 위해 도착한다. 그는 인간들을 구원할 영웅의 운명을 타고난 전사 베오울프! 그가 맞서야 하는 괴물은 인간 세계를 장악하려는 마녀와 온 세상을 지배하기 위해 절대악과 손잡은 왕 사이에서 태어난 괴물 그렌델이었다. 이제 인간을 위해 그들에 맞서 전설의 황금보검을 손에 쥔 태초의 영웅 베오울프. 그에게는 인류의 운명이 걸려 있고 그가 가는 길 앞에는 거대한 시련이 예정되어 있는데…",
        cast:["레이 윈스턴","안소니 홉킨스", "존 말코비치", "로빈 라이트", "안젤리나 졸리"],
        background:"북유럽",
        adaptation:"시대배경만 일치",
        keyword:["서사시","북유럽"],
        src:"3tkkCkM7wEM"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"2007_pathfinder.jpg",
        title:"패스파인더",
        englishTitle:"Pathfinder",
        release:[2007,4],
        country:["미국"],
        type:["영화"],
        genre:["액션","어드벤처"],
        playTime:["1시간 39분"],
        creater:["마커스 니스펠","마이크 메다보이","아놀드 메저","브래들리 J. 피셔","리 넬슨","리타 캘로그리디스","존M.제이콥슨"],
        synopsis:"바이킹 대 아메리카 원주민 간의 부족 전쟁이 끝난 후 전쟁통에 한 바이킹 소년이 낙오된다. 소년은 아메리카 원주민들의 손에 키워지게 되고, 후에 그들을 도와 노르인의 침략에 맞서 싸우며 부족의 영웅이 되기에 이른다.",
        cast:["칼 어번","문 블러드굿","클랜시 브라운","랄프 묄러","러셀 민스","너새니얼 아캔드"],
        background:"아메리카",
        adaptation:"각색된 역사",
        keyword:["바이킹","인디언","원작이 존재"],
        src:"6XM4LpL1iMc"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"2003_onceuponatimeinabattlefield.jpg",
        title:"황산벌",
        englishTitle:"Once Upon A Time In A Battlefield",
        release:[2003,10],
        country:["한국"],
        type:["영화"],
        genre:["블랙코미디"],
        playTime:["1시간 44분"],
        creater:["이준익","최석환", "조철현"],
        synopsis:"고구려, 신라, 백제 3국의 분쟁이 끊이질 않았던 660년, 딸의 원수인 백제 의자왕에게 앙심을 품은 김춘추는 당나라와 나당 연합군을 결성하여 김유신 장군에게 당나라의 사령관인 소정방과의 협상을 명령한다. 나이로 밀어부치려던 김유신. 불과 몇 년 차이로 소정방에게 밀리게 되고, 결국 7월 10일까지 조공을 조달해야 한다. 덕물도 앞바다까지 조공을 운반하기 위해선 백제군을 뚫어야 하는데, 백제에는 김유신의 영원한 숙적 계백 장군이 버티고 있다, 고구려를 치러 가는 것일 거라고 애써 자위하던 그들은 신라군이 남하하여 탄현으로 오고 있다는 전갈에 신라와 당나라가 백제를 공격하려는 것임을 확인하며 불안에 휩싸인다. 그러나, 의자왕에게 적개심을 품은 중신들은 자신들의 군사를 내 주지 못하겠노라 엄포를 놓고, 의자왕은 자신의 마지막 충신 계백 장군을 부른다. 무언의 술 다섯 잔 속에 의자왕으로부터 황산벌 사수를 부탁받은 계백은 목숨 바쳐 싸우기 위해 자신의 일족까지 모두 죽이고 황산벌로 향하는데...",
        cast:["박중훈", "정진영", "이문식", "류승수"],
        background:"삼국시대",
        adaptation:"각색된 역사",
        keyword:["삼국시대","황산벌"],
        src:"WM1Z07gjFI4"
    },
    {
        category:"중세 초기",
        age:"5세기 - 10세기",
        img:"1998_mulan.jpg",
        title:"뮬란",
        englishTitle:"Mulan",
        release:[1998,6],
        country:["미국"],
        type:["영화"],
        genre:["애니메이션","전쟁"],
        playTime:["1시간 21분"],
        creater:["베리 쿡","토니 밴크로프트", "리타 샤오","크리스 샌더스","팸 코츠"],
        synopsis:"파씨 가문의 말썽꾸러기 외동딸 뮬란은 선머슴 같은 성격에 강한 자아를 가지고 있어, 가문의 명예를 걸고 중매쟁이를 만나러 가서도 거듭되는 실수로 퇴짜를 맞게 된다. 뮬란은 나름대로는 부모님과 가문의 자랑이 되려고 노력하지만 그것이 그녀에게는 쉬운 일은 아니다. 한편, 훈족이 국경을 침략하자 황제는 가문에 한 사람씩 전쟁터로 나가라는 징집 명령을 내린다. 파씨 가문 역시 징집 명령을 받게 되고, 충성심이 강한 아버지는 전쟁에 나갈 준비를 한다. 그러나 뮬란은 지병이 있는 아버지가 전쟁에 나가도록 할 순 없다고 결심하고, 마침내 아버지 대신 갑옷을 입고 전쟁터로 향하게 된다.",
        cast:["밍나 원", "에디 머피", "B.D. 웡"],
        background:"남북조시대",
        adaptation:"각색된 역사",
        keyword:["남북조시대","화목란"],
        src:"HKH7_n425Ss"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"2019_1019.jpg",
        title:"평화전쟁 1019",
        englishTitle:"1019",
        release:[2019, 11],
        country:["한국"],
        type:["TV 프로그램"],
        genre:["다큐멘터리","드라마"],
        playTime:["2부작"],
        creater:["이규연","장미","이다운","박민경","길승수"],
        synopsis:"《평화전쟁 1019》는 2019년 11월 23일부터 24일까지 방송된 JTBC 창작특집 다큐멘터리로, 고려와 동북아의 운명을 갈랐던 여요전쟁 중 제2차, 제3차 전쟁을 다뤘다. 제1부 〈고려의 전사들〉, 제2부 〈신화가 된 대첩〉로 구성되어 있다. 몽골에서 촬영하였으며, 거란 측 인물들도 몽골인 배우가 연기했다. 그래서 그들의 대사도 전부 몽골어이다. 거란 대하씨의 직계 후손인 다우르족 중에서 캐스팅을 하는 것이 어렵기도 하고, 한국인이 다우르어로 연기하면 한국어 억양의 어눌한 그들의 언어가 되어버리는 문제가 있기 때문이다.",
        cast:["김명수","이우승","권영민","임우철 ","Uuganbavar Enkhbayar","Bayaraa Khasbazar","Erdenebileg Indernaa"],
        background:"영국",
        adaptation:"실제 역사에 가까운",
        keyword:["다큐멘터리","고려","여요전쟁"],
        src:"pwtaNbLTumk"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"2017_pilgrimage.jpg",
        title:"필그리미지",
        englishTitle:"Pilgrimage",
        release:[2017, 8],
        country:["아일랜드","벨기에","미국"],
        type:["영화"],
        genre:["모험", "드라마","스릴러","미스터리"],
        playTime:["1시간 36분"],
        creater:["브렌든 멀다우니","제이미 해니건","코너 배리", "존 케빌레"],
        synopsis:"십자군 전쟁이 한창이던 때, 아일랜드의 한 수도원에서는 성물을 지키고 있었다. 교황은 십자군 전쟁에서 승리하기 위해 이를 로마로 들고 오기를 원했고, 로마에서 온 수도자가 아일랜드에서 성물을 지켜왔던 “디아뮈드”(톰 홀랜드)와 “벙어리”(존 번설), 수도자들은 함께 로마로 향한다. 성물을 가지고 로마로 가는 도중에, 이를 노리는 자인 ”레이몬드”(리처드 아미티지)의 일행이 나타나 죽을 위협에 처하게 되는데…",
        cast:["톰 홀랜드", "존 번설", "리처드 아미티지"],
        background:"아일랜드",
        adaptation:"각색된 역사",
        keyword:["십자군 전쟁"],
        src:"3f3toYy63KA"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"2010_robinhood.jpg",
        title:"로빈 후드",
        englishTitle:"Robin Hood",
        release:[2010, 5],
        country:["미국"],
        type:["영화"],
        genre:["액션", "어드벤처", "드라마"],
        playTime:["2시간 20분"],
        creater:["리들리 스콧","브라이언 헬겔랜드", "에단 리프", "사이러스 보리스","러셀 크로우", "브라이언 그레이저"],
        synopsis:"13세기 영국. 평민 출신이지만 뛰어난 활실력을 가진 로빈후드는 리처드 왕의 용병으로 프랑스 전투에서 대활약을 펼쳐 왕의 신임을 받지만, 전투 중 리처드 왕이 전사한다. 리처드 왕에 이어 왕위에 오른 존 왕은 폭력적이고 탐욕적인 통치로 오랜 전쟁 후유증을 앓는 영국을 더욱 피폐하게 만든다. 국민들은 가난과 폭정에 시달리고 영국에는 모든 자유가 사라진 것. 전쟁 후 고향으로 돌아온 로빈후드는 이 모든 참담한 상황 속에서 자신의 돌아가신 아버지가 자유를 위해 왕권에 도전하다 처형당했다는 사실을 알게 되고, 동료들과 함께 부패한 존 왕에 맞서게 되는데…",
        cast:["러셀 크로우","케이트 블란쳇"],
        background:"영국",
        adaptation:"각색된 역사",
        keyword:["로빈 후드"],
        src:"3f3toYy63KA"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"2007_mongol.jpg",
        title:"몽골",
        englishTitle:"Mongol: The Rise Of Genghis Khan",
        release:[2007, 2],
        country:["러시아"],
        type:["영화"],
        genre:["액션" , "멜로/로맨스" , "전쟁"],
        playTime:["2시간 5분"],
        creater:["세르게이 보드로프","아리프 얄리예프","안톤 멜닉", "세르게이 셀야노브"],
        synopsis:"세력 다툼이 끊이지 않았던 12세기 몽골. 여기 훗날 인류의 영웅이자 대륙의 지배자로 불리게 되는 대 몽골 제국의 창시자, 테무진이 태어난다. 계속되는 투쟁과 혼란 속에서 일찍이 아버지를 잃은 소년 테무진은 어린 시절 결혼을 약속한 보르테를 다시 만나게 되면서 남자로서 갖추어야 할 의무와 소중한 것을 지키는 방법을 깨달아간다. 몇 년 후, 적에 의해 사랑하는 여인 보르테가 납치되는 아픔을 겪고 적의 아이를 배속에 품고 돌아온 그녀를 지켜보던 그는 모든 이들의 진정한 평화를 위해 몽골의 혼란을 끝내기로 마음먹고 진정한 칸으로 다시 태어나기로 결심하는데…",
        cast:["아사노 타다노부", "쑨훙레이", "쿨란 추루운"],
        background:"몽골",
        adaptation:"각색된 역사",
        keyword:["칭기즈 칸","몽골 제국"],
        src:"miMYoTL5qlE"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"2005_kingdomofheaven.jpg",
        title:"킹덤 오브 헤븐",
        englishTitle:"Kingdom of Heaven",
        release:[2005, 5],
        country:["미국"],
        type:["영화"],
        genre:["액션" , "드라마" , "스릴러" , "전쟁"],
        playTime:["2시간 17분", "3시간 9분(감독판)"],
        creater:["리들리 스콧","윌리엄 모나한"],
        synopsis:"전쟁으로 가족을 잃고 깊은 슬픔에 잠겨있는 프랑스의 젊은 대장장이 발리안에게 부상당한 십자군 기사 고프리가 찾아온다. 무언가 비밀을 품고 있는 듯한 그의 정체는 바로 발리안의 아버지. 발리안에게 숨겨진 전사의 자질을 꿰뚫어본 고프리는 자신과 함께 떠날 것을 제안하고, 발리안은 성스러운 도시를 지키기 위한 영예로운 여정을 시작한다. 발리안은 고프리로부터 여러 가지 검술과 전술 등을 배우며 용맹한 전사로 거듭난다. 그리고 고프리가 죽기 직전 수여한 작위를 받아 정식기사가 되어 성스러운 도시 예루살렘의 국왕 볼드윈 4세에 대한 충성을 서약하는데...",
        cast:["올랜도 블룸","에바 그린"," 에드워드 노튼","가산 마수드"],
        background:"예루살렘",
        adaptation:"각색된 역사",
        keyword:["고증이 좋은","십자군 전쟁"],
        src:"gg22TMYpkxk"
    },
    {
        category:"중세 성기",
        age:"11세기 - 13세기",
        img:"1995_braveheart.jpg",
        title:"브레이브 하트",
        englishTitle:"Braveheart",
        release:[1995, 5],
        country:["미국"],
        type:["영화"],
        genre:["액션" , "드라마", "전쟁"],
        playTime:["2시간 17분", "3시간 9분(감독판)"],
        creater:["멜 깁슨","브루스 대비", "알랜 라드 Jr", "엘리자베스 로빈슨"],
        synopsis:"13세기 스코틀랜드 영웅 윌리엄의 사랑과 투쟁을 그린 영화로 실화를 바탕으로 했다. 스코틀랜드가 잉글랜드 왕의 폭정에 시달리던 때에 윌리엄(멜 깁슨)이 저항군의 지도자가 되어 잉글랜드에 맞선다. 순종적이던 스코틀랜드인들은 윌리엄을 중심으로 단결하여 잉글랜드와의 전투에서 승리를 거둔다. 결국 잉글랜드는 윌리엄을 잡기 위해 계략을 쓰게 되는데...",
        cast:["멜 깁슨", "소피 마르소", "패트릭 맥고한", "캐서린 맥코맥"],
        background:"스코틀랜드",
        adaptation:"각색된 역사",
        keyword:["고증이 좋은","윌리엄 월레스","스코틀랜드 독립"],
        src:"nMft5QDOHek"
    },

    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2021_the kingoftears,leebangwon.jpg",
        title:"태종 이방원",
        englishTitle:"The King of Tears, Lee Bangwon[",
        release:[2021,12],
        country:["한국"],
        type:["TV 프로그램"],
        genre:["대하사극","피카레스크"],
        playTime:["32부작"],
        creater:["황의경","박춘호","강병택","김형일","심재현","이정우","안수현","김연진","권혜진 "],
        synopsis:"이방원은 누구인가. 그는 리더가 갖추어야 할 모든 자질을 보여주었다. 그리고 권력자가 짊어져야 할 모든 숙명을 보여주었다. 그리고 마지막엔, 모든 권력을 스스로 버릴 수 있다는 걸 보여주었다. 여말선초. 백성들이 한 치의 희망도 가질 수 없었던 그 시대. 불교와 봉건 귀족사회라는 구질서를 무너뜨리고 조선이라는 새로운 질서를 만들어가던 혁명적인 전환기. 그 격변의 시대를 가장 적극적으로 이끌었던 리더 이방원의 이야기가 시작된다.",
        cast:["주상욱", "김영철", "박진희", "예지원"],
        background:"조선",
        adaptation:"실제 역사에 가까운",
        keyword:["대하드라마","조선 전기"],
        src:"SfdDMzjxkXc"
    },
    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2021_thelastduel.jpg",
        title:"라스트 듀얼: 최후의 결투",
        englishTitle:"The Last Duel",
        release:[2021,10],
        country:["미국"],
        type:["영화"],
        genre:["드라마","스릴러"],
        playTime:["2시간 32분"],
        creater:["리들리 스콧","벤 애플렉","맷 데이먼","니콜 홀로프세너","제니퍼 폭스","케빈 J. 월시"],
        synopsis:"부조리한 권력과 야만의 시대, 14세기 프랑스. 장(맷 데이먼)은 영주 피에르(벤 애플렉)의 총애를 받는 자크(애덤 드라이버)에게 불만을 품고 있다. 그러다 피에르에 의해 마르그리트(조디 코머)의 결혼 지참금인 토지를 자크에게 빼앗기게 되자 자크에 대한 적대감이 극에 달한다. 한편 마르그리트에게 첫눈에 반한 자크는 장이 집을 비운 사이 마르그리트를 찾아가 겁탈한다. 용서받지 못할 짓을 저지른 자크는 마르그리트에게 침묵을 강요하지만, 마르그리트는 자신이 입을 여는 순간 감내해야 할 불명예를 각오하고 용기를 내어 자크의 죄를 고발한다. 강간사건에 대한 재판이 시작되고, 서로의 입장이 맹렬히 충돌하면서 파열음을 낸다. 결국 한때 전우였던 장과 자크는 승리한 자가 무죄, 패한 자가 유죄가 되는 결투 재판에서 승부를 겨루게 되는데...",
        cast:["맷 데이먼", "애덤 드라이버", "조디 코머", "벤 애플렉"],
        background:"프랑스",
        adaptation:"실제 역사에 가까운",
        keyword:["결투 재판","원작이 존재"],
        src:"bO1cG93mpNM"
    },
    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2019_theking.jpg",
        title:"더 킹: 헨리 5세",
        englishTitle:"The King",
        release:[2019,10],
        country:["미국"],
        type:["영화"],
        genre:["전기" , "드라마"],
        playTime:["2시간 13분"],
        creater:["데이비드 미쇼","조엘 에저튼","데드 가드너","제레미 클레이너","브래드 피트","리즈 와츠"],
        synopsis:"잉글랜드 왕의 후계자가 될 생각은 조금도 없는 방탕한 왕자, 할. 그는 왕궁을 등진 채 민중들과 어울려 지내고 있다. 하지만 아버지가 돌아가신 후 장남인 그는 헨리 5세로 즉위하고, 그동안 그토록 피하고 싶었던 삶을 살 수밖에 없다. 왕궁 내 정치와 혼란, 아버지가 남긴 전쟁을 이끌어가야 하는 젊은 왕. 뿐만 아니라 그는 가장 친한 친구이자 멘토였지만 이제는 늙은 알코올중독자가 되어버린 기사 존 폴스타프를 포함해, 과거의 삶과 관련된 감정들로 괴로워한다.",
        cast:["티모시 샬라메","조엘 에저튼","로버트 패틴슨"],
        background:"프랑스",
        adaptation:"실제 역사에 가까운",
        keyword:["아쟁쿠르 전투","헨리 5세"],
        src:"iX_9QIw49tM"
    },
    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2018_outlawking.jpg",
        title:"아웃로 킹",
        englishTitle:"Outlaw King",
        release:[2018,9],
        country:["영국"],
        type:["영화"],
        genre:["액션","전기" , "드라마"],
        playTime:["2시간 17분"],
        creater:["데이비드 매켄지","배스시바 도란","제임스 맥킨즈", "데이비드 해로워","마크 봄백"],
        synopsis:"종이 될 것인가. 왕이 될 것인가. 영국에 충성을 약속한 스코틀랜드 귀족 로버트 브루스. 굴종의 치욕을 씻기 위해, 그가 피를 나눈 형제들과 함께 반란을 일으킨다.",
        cast:["크리스 파인", "스티븐 딜레인", "플로렌스 퓨"],
        background:"스코틀랜드",
        adaptation:"실제 역사에 가까운",
        keyword:["로버트 1세","스코틀랜드 독립"],
        src:"bIcTWPQw_CQ"
    },
    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2013_thefacereader.jpg",
        title:"관상",
        englishTitle:"The Face Reader",
        release:[2013,9],
        country:["한국"],
        type:["영화"],
        genre:["드라마"],
        playTime:["2시간 19분"],
        creater:["한재림","김동혁", "한재림", "주필호","김우재","방미정"],
        synopsis:"얼굴을 보면 그 사람의 모든 것을 꿰뚫어보는 천재 관상가 내경. 처남 ‘팽헌’, 아들 ‘진형’과 산속에 칩거하고 있던 그는 관상 보는 기생 ‘연홍’의 제안으로 한양으로 향하고, 연홍의 기방에서 사람들의 관상을 봐주는 일을 하게 된다. 용한 관상쟁이로 한양 바닥에 소문이 돌던 무렵, ‘내경’은 ‘김종서’로부터 사헌부를 도와 인재를 등용하라는 명을 받아 궁으로 들어가게 되고, ‘수양대군’이 역모를 꾀하고 있음을 알게 된 그는 위태로운 조선의 운명을 바꾸려 한다.",
        cast:["송강호", "이정재", "백윤식", "조정석", "이종석", "김혜수"],
        background:"조선 전기",
        adaptation:"각색된 역사",
        keyword:["조선 전기","계유정난"],
        src:"oomGZYW3SOs"
    },
    {
        category:"중세 말기",
        age:"14세기 - 15세기",
        img:"2001_thewarriors.jpg",
        title:"무사",
        englishTitle:"The Warriors",
        release:[2001,9],
        country:["한국"],
        type:["영화"],
        genre:["무협","액션", "드라마"],
        playTime:["2시간 38분"],
        creater:["김성수","차승재", "조민환", "최정화"],
        synopsis:"고려 우왕 1년, 서력 1375년. 중국에선 주원장이 원나라를 만리장성 이북으로 밀어내고 명나라를 세웠으나, 원의 부흥세력은 강력히 저항하고 있었다. 당시 고려와 명의 관계는 공민왕 시해사건과 명사신 살해사건으로 인해 악화되어 있었다. 명나라에 사신으로 갔다 간첩혐의를 받고 귀양길에 오르게 된 고려의 무사들. 부사 이지헌(송재호 분)과 그의 호위무사 여솔(정우성 분), 용호군의 젊은 장수 최정(주진모 분), 최정의 부관인 가남(박정학 분), 주진군 일행과 대장 진립(안성기 분). 귀양길로 향하던 중 몽고군의 습격을 받아 명군은 전멸당하고, 고려인들만 사막에 고립된다. 더 이상 사신단의 의무를 할 수 없으므로 돌아가 명나라의 입장을 알려야 한다는 최정과 명군을 기다려야 한다는 이지헌쪽으로 의견이 나뉜다. 하지만 최정은 고려로 돌아갈 것을 명령하고 혹독한 강행군을 시작한다. 뜨거운 태양과 강행군에 지쳐가는 고려인들. 이지헌 부사는 쉬어가길 요청하지만 묵살당한다. 죽음을 예감한 그는 마지막 유언으로 노비였던 여솔을 자유롭게 풀어준다. 이윽고 도착한 객잔. 고려인들은 명나라 공주를 납치한 몽고군과 다시 마주친다. 비록 명나라에 패했지만 그들의 세력은 아직도 위세를 떨치고 있었다. 부용공주(장쯔이 분)가 탄 마차가 고려인 앞을 지나칠 때 마차에서 천 하나가 떨어진다. 거기에는 피로 적힌 '救(구원할 구)'가 쓰여있다. 최정은 고려로 돌아갈 계획을 변경한다. 부용공주를 구출해 명분도 세우고, 고려로 돌아갈 배를 얻겠다는 생각이다. 하지만 이를 반대하는 가남과 주진군. 한편 여솔은 다른 사람들보다 뒤늦게 이지헌의 시체를 끌고 객잔에 들어선다. 조용히 분노를 삭이고 있는 여솔, 색목인이 이지헌 시체에 침을 뱉자 바로 단칼에 베어버린다. 흥분한 색목인들이 몽고군 장수 람불화에게 구조를 요청하지만, 여솔의 창솜씨에 반한 그는 생포 명령을 내리는데..",
        cast:["안성기", "정우성", "주진모", "장쯔이"],
        background:"고려말",
        adaptation:"각색된 역사",
        keyword:["고려말"],
        src:"ZCZ-f2_C9Go"
    },

    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"2018_maryqueenofscots.jpg",
        title:"메리, 퀸 오브 스코틀랜드",
        englishTitle:"Mary Queen of Scots",
        release:[2018,12],
        country:["미국"],
        type:["영화"],
        genre:["드라마"],
        playTime:["2시간 4분"],
        creater:["조지 루크","보 윌리몬","팀 베번","에릭 펠너","데브라 헤이워드"],
        synopsis:"두 여왕이 공존할 수 있을까? 스코틀랜드 여왕 메리와 잉글랜드 여왕 엘리자베스. 한쪽은 가톨릭교, 한쪽은 개신교. 한쪽은 세 번의 결혼을, 한쪽은 국가와의 결혼을 했다. 강한 두 여성이 맞붙었다. 하나의 종교, 하나의 왕관을 위해.",
        cast:["시얼샤 로넌","마고 로비"],
        background:"스코틀랜드",
        adaptation:"각색된 역사",
        keyword:["메리 스튜어트", "원작이 존재"],
        src:"Ot5MHftOT7g"
    },
    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"2017_thefortress.jpg",
        title:"남한산성",
        englishTitle:"The Fortress",
        release:[2017,10],
        country:["한국"],
        type:["영화"],
        genre:["드라마", "스릴러","전쟁"],
        playTime:["2시간 20분"],
        creater:["황동혁","김지연","한흥석"],
        synopsis:"1636년 인조 14년 병자호란. 청의 대군이 공격해오자 임금과 조정은 적을 피해 남한산성으로 숨어든다. 추위와 굶주림, 절대적인 군사적 열세 속 청군에 완전히 포위된 상황, 대신들의 의견 또한 첨예하게 맞선다. 순간의 치욕을 견디고 나라와 백성을 지켜야 한다는 이조판서 최명길과 청의 치욕스런 공격에 끝까지 맞서 싸워 대의를 지켜야 한다는 예조판서 김상헌. 그 사이에서 인조의 번민은 깊어지고, 청의 무리한 요구와 압박은 더욱 거세지는데..",
        cast:["김윤석","이병헌"],
        background:"조선",
        adaptation:"실제 역사에 가까운",
        keyword:["병자호란","삼전도의 굴욕", "고증이 좋은", "원작이 존재"],
        src:"DNplhSG1LoI"
    },
    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"2015_theThrone.jpg",
        title:"사도",
        englishTitle:"The Throne",
        release:[2015,9],
        country:["한국"],
        type:["영화"],
        genre:["드라마"],
        playTime:["2시간 5분"],
        creater:["이준익", "조철현","이송원", "오승현"],
        synopsis:"재위기간 내내 왕위계승 정통성 논란에 시달린 영조는 학문과 예법에 있어 완벽한 왕이 되기 위해 끊임없는 노력을 기울인다. 뒤늦게 얻은 귀한 아들 세자만은 모두에게 인정받는 왕이 되길 바랐지만 기대와 달리 어긋나는 세자에게 실망하게 된다. 어린 시절 남다른 총명함으로 아버지 영조의 기쁨이 된 아들. 아버지와 달리 예술과 무예에 뛰어나고 자유분방한 기질을 지닌 사도는 영조의 바람대로 완벽한 세자가 되고 싶었지만 자신의 진심을 몰라주고 다그치기만 하는 아버지를 점점 원망하게 된다.",
        cast:["송강호", "유아인"],
        background:"조선",
        adaptation:"실제 역사에 가까운",
        keyword:["임오화변"],
        src:"MJnromBupnQ"
    },
    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"2014_roaringcurrents.jpg",
        title:"명량",
        englishTitle:"Roaring Currents",
        release:[2014,7],
        country:["한국"],
        type:["영화"],
        genre:["액션" , "드라마"],
        playTime:["2시간 8분"],
        creater:["김한민","전철홍"],
        synopsis:"1597년 임진왜란 6년, 오랜 전쟁으로 인해 혼란이 극에 달한 조선. 무서운 속도로 한양으로 북상하는 왜군에 의해 국가존망의 위기에 처하자 누명을 쓰고 파면당했던 이순신 장군이 삼도수군통제사로 재임명된다. 하지만 그에게 남은 건 전의를 상실한 병사와 두려움에 가득 찬 백성, 그리고 12척의 배 뿐. 마지막 희망이었던 거북선마저 불타고 잔혹한 성격과 뛰어난 지략을 지닌 용병 구루지마가 왜군 수장으로 나서자 조선은 더욱 술렁인다. 330척에 달하는 왜군의 배가 속속 집결하고 모두가 패배를 직감하는 순간, 이순신 장군은 단 12척의 배를 이끌고 바다를 향해 나서는데...",
        cast:["최민식","류승룡","조진웅","김명곤","진구",
        "이정현"],
        background:"조선",
        adaptation:"실제 역사에 가까운",
        keyword:["임진왜란","명량해전"],
        src:"spQtwggaCy4"
    },    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"1997_princessmononoke.jpg",
        title:"모노노케 히메",
        englishTitle:"Princess Mononoke",
        release:[1997,7],
        country:["일본"],
        type:["영화"],
        genre:["애니메이션","드라마","액션","어드벤처"],
        playTime:["1시간 13분"],
        creater:["미야자키 하야오","스즈키 토시오"],
        synopsis:"배경은 무로마치 시대 일본. 어느 날, 총알을 맞고 죽어가며 재앙신이 된 멧돼지 신 나고가 에미시 일족의 마을을 기습했다. 주인공 아시타카가 나고를 사살하지만, 그 원한의 대가로 저주에 걸려버린다. 그 저주는 아시타카의 뼈를 파고들어 결국 죽게 만드는 저주였다. 죽을 위기에 처한 아시타카는 자신의 생명을 갉아먹는 저주를 막기 위해 여행을 떠나게 된다. 서쪽으로의 여행 중 '타타라 마을'에 다다른 아시타카는 거기서 일어나는 인간과 신들의 전쟁에 끼어들게 되고 산이라는 야생의 소녀를 만나게 되는데...",
        cast:["마츠다 요지", "이시다 유리코"],
        background:"일본 무로마치시대",
        adaptation:"시대배경만 일치",
        keyword:["애니메이션", "시대고증"],
        src:"5iet4AxBK1U"
    },
    {
        category:"근세",
        age:"16세기 - 18세기 중반",
        img:"1992_thelastofthemohicans.jpg",
        title:"라스트 모히칸",
        englishTitle:"The Last Of The Mohicans",
        release:[1992,9],
        country:["미국"],
        type:["영화"],
        genre:["전쟁","멜로/로맨스","모험"],
        playTime:["112분", "117분(DVD 확장판)", "114분(블루레이 감독판)"],
        creater:["마이클 만","크리스토퍼 크로우","네드 도드","헌트 로우리"],
        synopsis:"1757년, 미국 식민지 시대. 부모를 잃은 영국계 백인 나다니엘 (다니엘 데이 루이스)은 쇠락해가는 모히칸족의 추장 칭가츠국의 아들 웅카스와 함께 형제처럼 키워진다. 아메리카 대륙을 차지하기 위한 영국과 프랑스의 전쟁은 격렬해지고 그 어느 쪽에도 속하길 원치 않은 모히칸족은 영국군의 강제징집 명령을 거부한다. 하지만, 우연히 영국군 사령관의 딸 코라 (매들린 스토우)와 그의 일행을 구하게 되고 나다니엘은 거스를 수 없는 운명처럼 사랑에 빠지게 된다. 그렇게 사랑하는 연인과 모히칸족의 미래를 위해 그는 처절한 전쟁의 소용돌이에 휘말리게 되는데…",
        cast:["다니엘 데이 루이스","매들린 스토","러셀 민스","에릭 슈웨이그"],
        background:"미국 식민지시대",
        adaptation:"각색된 역사",
        keyword:["미국 식민지시대"],
        src:"TgBklIqGFJU"
    },
    
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2019_aresistance.jpg",
        title:"항거: 유관순 이야기",
        englishTitle:"A Resistance",
        release:[2019,2],
        country:["한국"],
        type:["영화"],
        genre:["드라마"],
        playTime:["1시간 45분"],
        creater:["조민호","박현태", "조민호", "신혜연", "이정진"],
        synopsis:"일제강점기, 3.1 운동을 주도한 유관순은 옥살이를 하게 된다. 하지만 유관순은 굴하지 않고 일본에 저항하기 위해 수인들을 단합시킨다. 수상함을 느낀 일본인 보안과장은 관순의 동료를 꾀어 주동자가 유관순임을 알아내고 그녀에게 모진 고문을 가한다. 이후, 관순은 일본에 순종하는 척 하지만 몰래 또 다른 독립 운동을 준비한다. 이 운동은 감옥을 넘어 저자거리로 퍼져 나가고, 주동자인 관순은 다시 무자비한 고문을 당하게 된다. 결국 출소 이틀 전에 순국하지만, 그 어느 때보다 그녀의 영혼은 자유로워 보인다.",
        cast:["고아성", "김새벽", "김예은", "정하담", "류경수"],
        background:"일제강점기",
        adaptation:"실제 역사에 가까운",
        keyword:["일제강점기","유관순"],
        src:"cU_lhnaFNiA"
    },
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2018_mr.sunshine.jpg",
        title:"미스터 션사인",
        englishTitle:"Mr.Sunshine",
        release:[2018,7],
        country:["한국"],
        type:["TV 프로그램"],
        genre:["시대극" , "멜로" , "로맨스" , "드라마"],
        playTime:["24부작"],
        creater:["스튜디오드래곤","윤하림","이응복","김은숙"],
        synopsis:"2018년 7월 tvN에서 방영을 시작한 드라마. 신미양요(1871년)때 부모를 잃고 미 해군 군함 콜로라도 호에 승선해 미국에 떨어진 노비 출신 소년 유진(이병헌). 미국으로 건너가 갖은 차별을 이겨내고 군인이 된 그는 자신을 버린 조국인 조선으로 와 주둔하게 된다. 그에게 조선이란 제 부모를 때려죽인 나라이자, 자신이 도망쳐 나온 나라였으며, 양반들이 개화의 탈을 쓰고 앞다투어 매국을 하는 야만의 나라일 뿐이었다. 그러던 중 그는 남들 몰래 조선의 독립을 위해 싸우는 조선 최고 명문가의 영애, 애신(김태리)을 만나게 되는데...",
        cast:["이병헌","김태리","유연석","김민정","변요한"],
        background:"구한말",
        adaptation:"각색된 역사",
        keyword:["구한말"],
        src:"4YTXB5qkGzI"
    },
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2017_anarchistfromcolony.jpg",
        title:"박열",
        englishTitle:"Anarchist from Colony",
        release:[2017,6],
        country:["한국"],
        type:["영화"],
        genre:["시대극" , "전기" , "코미디"],
        playTime:["2시간 9분"],
        creater:["이준익","황성구","김성철"],
        synopsis:"1923년, 관동대지진 이후 퍼진 괴소문으로 6천여 명의 무고한 조선인이 학살된다. 사건을 은폐하기 위해, 관심을 돌릴 화젯거리가 필요했던 일본내각은 불령사를 조직해 항일운동을 하던 조선 청년 박열을 대역사건의 배후로 지목한다. 일본의 계략을 눈치챈 박열은 동지이자 연인인 가네코 후미코와 함께 일본 황태자 폭탄 암살 계획을 자백하고, 사형까지 무릅쓴 역사적인 재판을 시작하는데...",
        cast:["이제훈","최희서"],
        background:"구한말",
        adaptation:"실제 역사에 가까운",
        keyword:["구한말","일제강점기","박열"],
        src:"khSTSCXLRSA"
    },
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2015_therevenant.jpg",
        title:"레버넌트: 죽음에서 돌아온 자",
        englishTitle:"The Revenant",
        release:[2015,12],
        country:["미국"],
        type:["영화"],
        genre:["모험" , "액션" , "드라마" , "스릴러","복수극","서부극"],
        playTime:["2시간 36분"],
        creater:["알레한드로 곤살레스 이냐리투","마크 L. 스미스","스티브 골린키스 레드몬","데이비드 캔터","아논 밀천","제임스 스코치도폴"],
        synopsis:"서부 개척시대 이전인 19세기 아메리카 대륙, 전설적인 모피 사냥꾼인 휴 글래스(레오나르도 디카프리오)는 아들 호크를 데리고 동료들과 함께 사냥하던 중 회색곰에게 습격 당해 사지가 찢긴다. 하지만 돈에 눈이 먼 비정한 동료 존 피츠 제럴드(톰 하디)는 아직 살아 있는 휴를 죽이려 하고, 아들 호크가 이에 저항하자 호크마저 죽인 채 숨이 붙어 있는 휴를 땅에 묻고 떠난다. 눈 앞에서 하나뿐인 아들의 죽음을 목격한 휴는 처절한 복수를 위해 부상 입은 몸으로 배신자 존 피츠제럴드의 뒤를 쫓아 300km가 넘는 광활하고 거친 야생에서 인간의 한계에 도전하는데...",
        cast:["레오나르도 디카프리오","톰 하디","도널 글리슨","윌 폴터"],
        background:"미국 서부",
        adaptation:"각색된 역사",
        keyword:["원작이 존재","휴 글래스"],
        src:"LBCcrqjD2_Y"
    },
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2015_intheheartofthesea.jpg",
        title:"하트 오브 더 씨 ",
        englishTitle:"In the Heart of the Sea",
        release:[2015,12],
        country:["미국"],
        type:["영화"],
        genre:["모험" , "액션" , "드라마"],
        playTime:["1시간 52분"],
        creater:["론 하워드","찰스 리빗", "릭 자파", "아만다 실버", "피터 모건", "나다니엘 필브릭(원작)"],
        synopsis:"1850년 미국 매사추세츠 낸터킷 섬. 어두운 밤, 허먼 멜빌은 급한 발걸음으로 누군가의 집을 찾는다. 그는 바로 94일간 7,200km 표류했던 21명의 조난대원들 중 살아남은 8명 중 한 사람. 허먼 멜빌의 끈질긴 요청과 부인의 간곡한 부탁으로 그는 누구에게도 이야기하지 않았던, 지옥과도 같았던 그때의 기억을 조심스레 꺼낸다. 1819년 여름, 포경선 에식스호는 낸터킷 섬에서 항해에 올랐다. 그러나 15개월 뒤, 남태평양의 한가운데서 길이 30m, 무게 80톤의 성난 향유고래의 공격을 당하면서 238톤의 배가 단 10분 만에 침몰한다. 침몰한 배에서 살아 남은 21명의 선원들은 3개의 보트에 나눠 타고 육지를 찾아 나서지만 남아있던 건빵도 식수도 떨어져 간다. 가족보다 더욱 끈끈했던 그들은 거친 폭풍우와 절망, 고독, 양심과 싸우면서 먹을 것도, 희망도 없는 망망대해에서 살아남기 위해 인간으로서 가장 비극적인 선택을 해야만 하는데…",
        cast:["크리스 헴스워스", "톰 홀랜드","킬리언 머피", "벤 위쇼", "샬럿 라일리", "미셸 페어리", "폴 앤더슨", "브렌던 글리슨", "벤저민 워커"],
        background:"미국",
        adaptation:"각색된 역사",
        keyword:["원작이 존재","모비 딕"],
        src:"e-IHEv2eAFg"
    },
    {
        category:"근대",
        age:"18세기 중반 - 20세기 초반",
        img:"2012_lesmisérables.jpg",
        title:"레미제라블",
        englishTitle:"Les Misérables",
        release:[2012,12],
        country:["미국"],
        type:["영화"],
        genre:["드라마" , "뮤지컬" , "로맨스"],
        playTime:["2시간 38분"],
        creater:["톰 후퍼","윌리엄 니컬슨", "알랭 부브릴", "클로드미셸 숀베그", "허버트 크래츠머","팀 비번","에릭 펠너","캐머런 매킨토시","데브라 헤이워드"],
        synopsis:"빵 한 조각을 훔친 죄로 19년의 감옥살이를 한 장발장(휴 잭맨). 우연히 만난 신부의 손길 아래 구원을 받고 새로운 삶을 결심한다. 정체를 숨기고 마들렌이라는 새 이름으로 가난한 이들을 도우던 장발장은 운명의 여인, 판틴(앤 해서웨이)과 마주치고, 죽음을 눈앞에 둔 판틴은 자신의 유일한 희망인 딸 코제트(아만다 사이프리드)를 장발장에게 부탁한다. 그러나 코제트를 만나기도 전에 경감 자베르(러셀 크로우)는 장발장의 진짜 정체를 알아차리고, 오래된 누명으로 다시 체포된 장발장은 코제트를 찾아 탈옥을 감행하는데...",
        cast:["레오나르도 디카프리오","톰 하디","도널 글리슨","윌 폴터"],
        background:"프랑스",
        adaptation:"각색된 역사",
        keyword:["원작이 존재","뮤지컬"],
        src:"Qei594KgLgM"
    },

    {   
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2019_1917.jpg",
        title:"1917",
        englishTitle:"1917",
        release:[2019,12],
        country:["미국"],
        type:["영화"],
        genre:["드라마","전쟁","실화"],
        playTime:["1시간 59분"],
        creater:["샘 멘데스","피파 해리스","칼럼 맥도걸","제인앤 텡그렌","브라이언 올리버","크리스티 윌슨케언스"],
        synopsis:"제1차 세계대전이 한창인 1917년 4월 6일. 독일군에 의해 모든 통신망이 파괴된 상황 속에서 서부전선의 영국군 병사 스코필드(조지 맥케이)와 블레이크(딘-찰스 채프먼)에게 하나의 미션이 주어졌다. 독일군의 함정에 빠진 영국군 부대의 수장 매켄지 중령(베네딕트 컴버배치)에게 에린무어 장군(콜린 퍼스)의 공격 중지 명령을 전달하라는 것. 블레이크는 데본셔 연대에 있는 형(리차드 매든)을 구하기 위해 기꺼이 임무를 수행한다. 동료인 스코필드는 처음엔 당황스러워하지만 이내 1600명의 동료들을 구하기 위해 전쟁터 한가운데를 가로지르는 여정에 동참한다.",
        cast:["조지 맥케이", "딘찰스 채프먼","콜린 퍼스","마크 스트롱","베네딕트 컴버배치","리처드 매든","앤드류 스콧"],
        background:"영국",
        adaptation:"실제 역사에 가까운",
        keyword:["제1차 세계대전","롱테이크"],
        src:"ZIQbJemUedU"
    },
    {
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2017_dunkirk.jpg",
        title:"덩케르크",
        englishTitle:"Dunkirk",
        release:[2017,7],
        country:["미국"],
        type:["영화"],
        genre:["액션","드라마","스릴러","전쟁"],
        playTime:["1시간 46분"],
        creater:["크리스토퍼 놀란","에마 토머스"],
        synopsis:"제2차 세계대전 당시인 1940년, 프랑스 덩케르크 지역에서 진행된 연합군 구출 작전. 영화는 세개의 시공간을 동시에 진행시킨다. 도버 해협을 건너려는 영국군을 중심으로 한 잔교에서의 일주일, 민간 선박들의 자발적 참전과 차출이 이어지는 바다에서의 하루, 적기를 겨냥한 스피트파이어기 전투사가 있는 하늘에서의 한 시간. 전쟁의 전방위성, 공포의 상시성과 그 압도, 개별 공간을 떠난 공포의 유사성, 그 속의 다급함이 혼재되어 있는 가운데 전쟁과 죽음에의 공포와 생존을 향한 인간적 열망을 그린다.",
        cast:["핀 화이트헤드", "톰 하디", "케네스 브래너","마크 라이런스", "해리 스타일스", "잭 로던"],
        background:"프랑스",
        adaptation:"실제 역사에 가까운",
        keyword:["제2차 세계대전","됭케르크 철수작전"],
        src:"XUhRA_ObaDo"
    },
    {   
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2014_theimitationgame.jpg",
        title:"이미테이션 게임",
        englishTitle:"The Imitation Game",
        release:[2014,11],
        country:["미국"],
        type:["영화"],
        genre:["드라마","전기","실화"],
        playTime:["1시간 54분"],
        creater:["모튼 틸덤","그레이엄 무어","노라 그로스먼","이도 오스트로우스키","테디 슈워츠먼"],
        synopsis:"매 순간 3명이 죽는 사상 최악의 위기에 처한 제 2차 세계대전. 절대 해독이 불가능한 암호 에니그마로 인해 연합군은 속수무책으로 당하게 된다. 결국 각 분야의 수재들을 모아 기밀 프로젝트 암호 해독팀을 가동한다. 천재 수학자 앨런 튜링은 암호 해독을 위한 특별한 기계를 발명하지만 24시간 마다 바뀌는 완벽한 암호 체계 때문에 번번히 좌절하고 마는데... 과연, 앨런 튜링과 암호 해독팀은 암호를 풀고 전쟁의 승리를 끌어낼 수 있을까…?",
        cast:["베네딕트 컴버배치", "키이라 나이틀리"],
        background:"미국",
        adaptation:"실제 역사에 가까운",
        keyword:["제2차 세계대전","앨런 튜링"],
        src:"r9VQGDs7iVc"
    },
    {   
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2014_fury.jpg",
        title:"퓨리",
        englishTitle:"FURY",
        release:[2014,10],
        country:["미국"],
        type:["영화"],
        genre:["전쟁","드라마","액션"],
        playTime:["10부작"],
        creater:["데이비드 에이어","빌 블록","존 레셔","앨릭스 오트","에단 스미스","앤턴 레신","사샤 샤피로","벤 웨이스브렌"],
        synopsis:"2차 세계대전, 전차부대를 이끄는 대장 워대디에게 적으로 둘러싸인 최전선에서의 마지막 전투 명령이 떨어진다. 하지만 수 차례의 전투로 대부분의 동료를 잃은 그에겐 단 한 대의 탱크 퓨리와 지칠 대로 지쳐버린 부대원들만이 남아있을 뿐. 게다가 지원군으로 경력이 전무한 신병 노먼이 배치되고, 워대디는 신참을 포함한 단 4명의 부대원만으로 적진에 나서야 하는 상황에 처한다. 수백 명의 적들과 맞서야 하는 단 5인의 병사. 최소의 인원과 최악의 조건 속, 사상 최대 위기에 처한 워대디와 그의 부대는 생존 가능성 제로인 최후의 전쟁터로 향하는데...",
        cast:["브래드 피트", "로건 레먼", " 샤이아 라보프", "마이클 페냐", "존 번설" , "스콧 이스트우드", "자비에르 사무엘"],
        background:"독일",
        adaptation:"각색된 역사",
        keyword:["제2차 세계대전","밀리터리"],
        src:"avCN6gqjJkY"
    },
    {   
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2002_thepianist.jpg",
        title:"피아니스트",
        englishTitle:"The Pianist",
        release:[2002,5],
        country:["프랑스"],
        type:["영화"],
        genre:["전쟁","드라마","음악","실화"],
        playTime:["2시간 28분"],
        creater:["로만 폴란스키","로날드 하우드"],
        synopsis:"1939년 폴란드 바르샤바. 유명한 유대계 피아니스트 블라디슬로프 스필만은 한 인기 라디오 프로그램에서 쇼팽의 야상곡을 연주하다 폭격을 당한다. 이후 유태인인 스필만과 가족들은 게토에서 생활하지만, 결국 수용소로 향하는 기차에 몸을 싣게 된다. 가족들을 죽음으로 내보내고 간신히 목숨을 구한 스필만은 허기와 추위, 고독과 공포 속에서 마지막까지 생존을 지켜나간다. 나치의 세력이 확장될 수록 자신을 도와주던 몇몇의 사람마저 떠나자 완전히 혼자가 되어 자신만의 은신처에서 끈질기게 생존을 유지하는 스필만. 어둠과 추위로 가득한 폐건물 속에서 은신생활 중 스필만은 우연찮게 순찰을 돌던 독일 장교에게 발각되고 지상에서의 마지막 연주가 될 지도 모르는 순간, 온 영혼을 손끝에 실어 연주를 시작하는데…",
        cast:["에이드리언 브로디", "토마스 크레치만"],
        background:"폴란드",
        adaptation:"실제 역사에 가까운",
        keyword:["제2차 세계대전","전쟁","홀로코스트","원작이 존재"],
        src:"dEF4g7gf7C4"
    },
    {   
        category:"세계대전",
        age:"20세기 초반 - 20세기 중반",
        img:"2001_bandofbrothers.jpg",
        title:"밴드 오브 브라더스",
        englishTitle:"Band of Brothers",
        release:[2001,9],
        country:["미국"],
        type:["TV 프로그램"],
        genre:["전쟁","드라마","액션"],
        playTime:["10부작"],
        creater:["스티븐 스필버그","톰 행크스"],
        synopsis:"2001년 9월 HBO에서 방영을 시작한 전쟁물. 스티븐 앰브로즈의 동명의 저서를 원작으로 한다. 제2차 세계대전의 노르망디 상륙작전의 D-Day부터 1945년 8월 15일 일본 제국이 항복하여 전쟁이 끝날 때까지 미 육군 제 101 공수사단 제 506 낙하산보병연대 제 2대대 제 5중대(일반적으로 5번째 알파벳의 E를 딴 Easy 중대)의 초기 훈련부터 노르망디 상륙 작전, 벌지 전투 등을 거쳐, 마지막으로는 히틀러의 별장인 독수리 둥지(Eagle's Nest) 점령 등 의 에피소드를 실제 전투에 참가했던 중대원들의 증언을 바탕으로 하고 있다.",
        cast:["Damian Lewis", "Donnie Wahlberg", "Eion Bailey", "Ron Livingston", "Matthew Settle" , "Michael Cudlitz", "Neal McDonough"],
        background:"유럽 전역",
        adaptation:"실제 역사에 가까운",
        keyword:["제2차 세계대전","밀리터리","원작이 존재","HBO"],
        src:"sURlNOFvfQ4"
    },

    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"2018_firstman.jpg",
        title:"퍼스트맨",
        englishTitle:"First Man",
        release:[2018,10],
        country:["미국"],
        type:["영화"],
        genre:["전기","드라마"],
        playTime:["2시간 21분"],
        creater:["데미언 샤젤","마티 보언","윅 고드프리","아이작 크라스너","스티븐 스필버그","조시 싱어"],
        synopsis:"우주 경쟁에서 러시아에 뒤처지고 있다는 열패감이 팽배한 1960년대. 닐 암스트롱은 NACA의 엔지니어 겸 시험 비행 조종사로, 대기권을 넘어 우주로 가기 위한 시험비행을 계속한다. 혁신적인 기술로 만든 기계의 결함을 점검하고 보완하는 일을 하는 것이 그의 주요 임무로, 암스트롱은 회사와 집을 오가며 성실하게 자신의 역할을 수행한다. 마침내 이제껏 누구도 경험하지 못한 세계에 도전한 우주비행사 닐은 거대한 위험 속에서 극한의 위기를 체험하게 된다. 전 세계가 바라보는 가운데, 그는 새로운 세상을 열 첫 발걸음을 내딛는데...",
        cast:["라이언 고슬링", "클레어 포이 "],
        background:"미국",
        adaptation:"실제 역사에 가까운",
        keyword:["냉전","우주 경쟁"],
        src:"QVk-PU1xMjQ"
    },
    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"2015_bridgeofspies.jpg",
        title:"스파이 브릿지",
        englishTitle:"Bridge of Spies",
        release:[2015,10],
        country:["미국"],
        type:["영화"],
        genre:["드라마","스릴러"],
        playTime:["2시간 21분"],
        creater:["스티븐 스필버그","에단 코엔", "조엘 코엔", "맷 샤먼"],
        synopsis:"미국과 소련의 냉전으로 핵무기 전쟁의 공포가 최고조에 오른 1957년, 보험 전문 변호사 '제임스 도노반'(톰 행크스)은 소련 스파이 '루돌프 아벨'(마크 라이런스)의 변호를 맡게 된다. 당시 미국에선 전기기술자 로젠버그 부부가 원자폭탄 제조 기술을 소련에 제공했다는 혐의로 간첩죄로 사형된 사건이 있었다. 미국의 반공운동이 극에 달했던 단적인 예로 적국의 스파이를 변호한다는 것은 자신의 목숨은 물론 가족의 안전까지 위협받는 일이었다. 여론과 국민의 질타 속에서도 제임스 도노반은 “변론의 기회는 누구에게나 주어져야 한다”며 자신의 신념과 원칙에 따라 아벨의 변호에 최선을 다한다. 때마침 소련에서 격추당하고 생포된 CIA의 U-2 조종사 프란시스 개리 파워스에 대한 소식이 전해지고 제임스 도노반은 그를 구출하기 위해 스파이 맞교환이라는 사상 유례 없는 비밀협상에 나서게 되는데...",
        cast:["톰 행크스","마크 라이런스", "오스틴 스토웰", "윌 로저스", "에이미 라이언", "앨런 알다", "미하일 고레보이", "세바스티안 코흐", "제시 플레먼스"],
        background:"미국",
        adaptation:"실제 역사에 가까운",
        keyword:["냉전","첩보"],
        src:"hmY9lAS4Z3E"
    },
    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"2014_odetomyfather.jpg",
        title:"국제시장",
        englishTitle:"Ode to My Father",
        release:[2014,12],
        country:["한국"],
        type:["영화"],
        genre:["전쟁","가족","드라마"],
        playTime:["2시간 15분"],
        creater:["윤제균","박수진"],
        synopsis:"1950년대 한국전쟁 이후로부터 현재에 이르기까지 격변의 시대를 관통하며 살아온 우리 시대 아버지 덕수, 그는 하고 싶은 것도 되고 싶은 것도 많았지만 평생 단 한번도 자신을 위해 살아본 적이 없다. ‘괜찮다’ 웃어 보이고 ‘다행이다’ 눈물 훔치며 힘들었던 그때 그 시절, 오직 가족을 위해 굳세게 살아온 우리들의 아버지 이야기가 지금부터 시작된다.",
        cast:["황정민", "김윤진", "오달수", "정진영", "장영남", "라미란", "김슬기"],
        background:"한국",
        adaptation:"각색된 역사",
        keyword:["냉전","6.25전쟁","흥남 철수작전"],
        src:"BBEDtovULHY"
    },
    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"2004_taegukgi.jpg",
        title:"태극기 휘날리며",
        englishTitle:"TaeGukGi: Brotherhood Of War",
        release:[2004,2],
        country:["한국"],
        type:["영화"],
        genre:["전쟁","드라마"],
        playTime:["2시간 25분"],
        creater:["강제규","한지훈","김상돈"],
        synopsis:"가족의 생계를 책임지기 위해 열심히 살아가는 ‘진태’(장동건)는 약혼녀 ‘영신’(이은주)과의 결혼과, 세상에서 가장 소중하게 생각하는 동생 ‘진석’(원빈)의 대학 진학을 위해 어려운 상황에서도 씩씩하게 생활을 해나간다. 1950년 6월의 어느 날, 한반도에 전쟁이 일어났다는 호외가 배포되고, 두 형제는 평온한 일상에서 갑작스레 전쟁터로 내몰린다. 훈련받을 시간조차 없이 국군 최후의 보루인 낙동강 방어선으로 실전 투입된 ‘진태’와 ‘진석’. 동생과 같은 소대에 배치된 ‘진태’는 아직 학생인 동생의 징집 해제를 위해 대대장을 만나게 되고, 동생의 제대를 위해 자신이 해야 할 최선의 것이 무엇인지를 느끼게 된다. 그리고 동생의 생존을 위해 총을 들며 영웅이 되기를 자처하게 되고, 끝내 생각지도 못한 운명의 덫이 두 형제를 기다리고 있는데…",
        cast:["장동건", "원빈", "이은주", "공형진"],
        background:"한국",
        adaptation:"각색된 역사",
        keyword:["냉전","6.25전쟁"],
        src:"0QYEwyxMplY"
    },
    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"1987_fullmetaljacket.jpg",
        title:"풀 메탈 재킷",
        englishTitle:"Full Metal Jacket",
        release:[1987,7],
        country:["한국"],
        type:["영화"],
        genre:["전쟁","드라마"],
        playTime:["1시간 56분"],
        creater:["스탠리 큐브릭","마이클 헤르","구스타프 하스포드","필립 홉스","마이클 허","잔 할랜"],
        synopsis:"남캐롤라이나 주 파리스 아일랜드의 신병훈련기지. 고등학교를 갓 졸업한 젊은이들은 여기에서 8주간을 지내면 살인기계가 되어 베트남 전장에 파견된다. 그들은 인정사정없는 하트만 교관에게 욕지거리를 들으며 단련된다. 훈련병 레나드는 무엇이든지 실수투성이어서 하트만에게 특별히 들볶임을 당하는데, 반장으로 임명된 조커는 레나드를 돌봐주라는 명령을 받지만 레나드의 실수 때문에 전원이 징벌받는 일이 끊이지 않는다. 어느날 밤, 레나드는 훈련병들에게 린치를 당하는데, 조커도 망설였지만 결국 참가하고 마는데...",
        cast:["매튜 모딘", "애덤 볼드윈", "빈센트 도노프리오", "로널드 리 어메이"],
        background:"베트남",
        adaptation:"각색된 역사",
        keyword:["냉전","베트남 전쟁","원작이 존재"],
        src:"n2i917l5RFc"
    },
    {
        category:"냉전",
        age:"20세기 중반 - 후반",
        img:"1964_dr.strangelove.jpg",
        title:"닥터 스트레인지러브 또는: 내가 어떻게 걱정을 떨치고 핵폭탄을 사랑하는 법을 배우게 되었는가?",
        englishTitle:"Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb",
        release:[1964,1],
        country:["한국"],
        type:["영화"],
        genre:["블랙 코미디","전쟁","드라마"],
        playTime:["1시간 42분"],
        creater:["스탠리 큐브릭","테리 서던","피터 조지"],
        synopsis:"미 공군의 잭 리퍼 장군(General Jack D. Ripper: 스터링 하이든 분)은 공산주의자들이 미국인의 ‘신성한 혈통’을 오염시킬 음모를 꾸미고 있다는 망상에 사로잡혀 핵폭격기를 출격시킨다. 미국 대통령은 절체절명의 위기를 해결 하기 위해 자문회를 소집하는데, 그 자리에서 소련 대사는 만일 소련이 핵공격을 당한다면 지구상의 모든 동식물이 파멸되는 ‘운명의 날’이 다가오게 될 것이라고 경고한다. 피터 셀러스는 이 비극을 막을 수 있는 세 인물의 역할을 맡고 있다. 셀러스는 1인 3역으로, 머킨 머플리 대통령(President Merkin Muffley), 발광한 리퍼 장군의 부관인 영국 공군 대위 라이오넬 맨드레이크(Group Capt. Lionel Mandrake), 전 나치주의자였던 천재 과학자 스트레인지러브 박사(Dr. Strangelove)로 등장한다. 영화 속에서 스트레인지 러브 박사는 핵무기에 지구의 운명이 달려있다는 사실이 너무 명백하므로 핵무기로 상황을 대응할 수 없다는 결론을 내린다. 과연 폭격기는 제 시간에 제거될 수 있을 것인가? 아니면 잭 리퍼 장군이 전세계를 파멸시키는데 성공 할 것인가? 남캐롤라이나 주 파리스 아일랜드의 신병훈련기지. 고등학교를 갓 졸업한 젊은이들은 여기에서 8주간을 지내면 살인기계가 되어 베트남 전장에 파견된다. 그들은 인정사정없는 하트만 교관에게 욕지거리를 들으며 단련된다. 훈련병 레나드는 무엇이든지 실수투성이어서 하트만에게 특별히 들볶임을 당하는데, 반장으로 임명된 조커는 레나드를 돌봐주라는 명령을 받지만 레나드의 실수 때문에 전원이 징벌받는 일이 끊이지 않는다. 어느날 밤, 레나드는 훈련병들에게 린치를 당하는데, 조커도 망설였지만 결국 참가하고 마는데...",
        cast:["피터 셀러스", "조지 C. 스콧", "스털링 헤이든"],
        background:"소련",
        adaptation:"각색된 역사",
        keyword:["냉전","블랙 코미디","원작이 존재"],
        src:"9CM19Jd3Gl8"
    },

    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2020_themanstandingnext.jpg",
        title:"남산의 부장들",
        englishTitle:"The Man Standing Next",
        release:[2020,1],
        country:["한국"],
        type:["영화"],
        genre:["드라마" , "첩보","시대극","느와르","스릴러","피카레스크","범죄","서스펜스"],
        playTime:["2시간 6분"],
        creater:["우민호","이지민","김원국"],
        synopsis:"1979년 10월 26일, 중앙정보부장 김규평(이병헌)이 대한민국 대통령(이성민)을 암살한다. 이 사건의 40일전, 미국에서는 전 중앙정보부장 박용각(곽도원)이 청문회를 통해 전 세계에 정권의 실체를 고발하며 파란을 일으킨다. 그를 막기 위해 중앙정보부장 김규평과 경호실장 곽상천(이희준)이 나서고, 대통령 주변에는 충성 세력들과 반대 세력들이 뒤섞이기 시작하는데…",
        cast:["이병헌","이성민", "곽도원", "이희준"],
        background:"한국",
        adaptation:"실제 역사에 가까운",
        keyword:["10.26 사건"],
        src:"FqyHdERatW8"
    },
    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2017_1987.jpg",
        title:"1987",
        englishTitle:"1987:When the Day Comes",
        release:[2017,12],
        country:["한국"],
        type:["영화"],
        genre:["시대극" , "드라마"],
        playTime:["2시간 9분"],
        creater:["장준환","김경찬","이우정","장영환"],
        synopsis:"1987년 1월, 경찰 조사를 받던 스물두 살 대학생이 사망한다. 박처장의 주도 하에 경찰은 시신 화장을 요청하지만, 사망 당일 당직이었던 최검사는 이를 거부하고 부검을 밀어붙인다. 단순 쇼크사인 것처럼 거짓 발표를 이어가는 경찰. 그러나 현장에 남은 흔적들과 부검 소견은 고문에 의한 사망을 가리키고, 사건을 취재하던 윤기자는 물고문 도중 질식사를 보도한다. 한편, 교도소에 수감된 조반장을 통해 사건의 진상을 알게 된 교도관 한병용은 이 사실을 수배 중인 재야인사에게 전달하기 위해 조카인 연희에게 위험한 부탁을 하게 되는데...",
        cast:["김윤석","하정우","유해진","김태리","강동원","박휘순","이희준"],
        background:"한국",
        adaptation:"실제 역사에 가까운",
        keyword:["박종철 고문치사 사건","6.10 민주 항쟁"],
        src:"WKQSRFlfr50"
    },
    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2015_thebigshort.jpg",
        title:"빅쇼트",
        englishTitle:"The Big Short",
        release:[2015,12],
        country:["미국"],
        type:["영화"],
        genre:["드라마", "코미디"],
        playTime:["2시간 10분"],
        creater:["애덤 맥케이","찰스 랜돌프","데드 가드너","제레미 클레이너","브래드 피트"],
        synopsis:"사회성이라곤 없는 캐피털 회사 대표 마이클 버리는 금융시장의 붕괴를 예측하고, 골드만삭스를 찾아가 부동산 폭락에 돈을 걸겠다고 말해 비웃음을 산다. 도이치뱅크의 트레이더인 자레드 베넷은 대형 은행들이 안전자산이라 홍보한 부채담보부증권의 부실을 파악하고 내부 정보를 투자자들에게 흘린다. 펀드매니저 마크 바움은 자레드에게서 제공받은 정보로 대형 은행과 반대되는 투자를 감행한다. 은퇴 뒤 은둔 중인 전직 트레이더 벤 리커트는 눈밝고 대담한 젊은 펀드매니저 찰리와 제이미를 돕는다.",
        cast:["크리스찬 베일","스티브 카렐", "라이언 고슬링", "브래드 피트"],
        background:"미국",
        adaptation:"각색된 역사",
        keyword:["원작이 존재","서브프라임 모기지사태"],
        src:"5NjZfn_3rMc"
    },
    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2015_stevejobs.jpg",
        title:"스티브 잡스",
        englishTitle:"Steve Jobs",
        release:[2015,10],
        country:["미국"],
        type:["영화"],
        genre:["전기", "드라마"],
        playTime:["2시간 2분"],
        creater:["대니 보일","에런 소킨","스콧 루딘","가이먼 캐서디","크리스천 콜슨","마크 고든"],
        synopsis:"3번의 혁신을 선사한 프레젠테이션 무대 40분 전. 3개의 프레젠테이션은 1984년의 매킨토시, 1988년의 넥스트 큐브 그리고 1998년의 아이맥 론칭 행사로, 영화는 이들 프레젠테이션이 시작되기 40분 전의 상황을 생생하게 전한다. 누구와도 같은 시각으로 세상을 바라보지 않았던 스티브 잡스는 타협 없는 완벽주의로 인해 그의 주변 인물들과 심각한 갈등을 겪게 된다. 힘든 행사를 준비해가는 과정에서 스티브 잡스와 그의 천재 친구들이 서로를 질투하고, 그래서 다투고, 상처를 입는데...",
        cast:["마이클 패스벤더","케이트 윈슬렛","세스 로건"],
        background:"미국",
        adaptation:"실제 역사에 가까운",
        keyword:["스티브 잡스"],
        src:"5NjZfn_3rMc"
    },
    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2013_theattorney.jpg",
        title:"변호인",
        englishTitle:"The Attorney",
        release:[2013,12],
        country:["한국"],
        type:["영화"],
        genre:["법정", "드라마"],
        playTime:["2시간 7분"],
        creater:["양우석","윤현호","이정화","김우택","정문구","최재원","양우석"],
        synopsis:"1980년대 초 부산 빽도 없고, 돈도 없고, 가방끈도 짧은 세무 변호사 송우석(송강호) 부동산 등기부터 세금 자문까지 남들이 뭐라든 탁월한 사업수완으로 승승장구하며 부산에서 제일 잘나가고 돈 잘 버는 변호사로 이름을 날린다. 10대 건설 기업의 스카우트 제의까지 받으며 전국구 변호사 데뷔를 코 앞에 둔 송변. 하지만 우연히 7년 전 밥값 신세를 지며 정을 쌓은 국밥집 아들 진우(임시완)가 뜻하지 않은 사건에 휘말려 재판을 앞두고 있다는 소식을 듣는다. 국밥집 아줌마 순애(김영애)의 간절한 부탁을 외면할 수 없어 구치소 면회만이라도 도와주겠다고 나선 송변. 하지만 그곳에서 마주한 진우의 믿지 못할 모습에 충격을 받은 송변은 모두가 회피하기 바빴던 사건의 변호를 맡기로 결심하는데...",
        cast:["송강호","김영애", "오달수", "곽도원", "임시완", "이성민"],
        background:"한국",
        adaptation:"각색된 역사",
        keyword:["노무현","부림사건"],
        src:"ZFlA0GSxX8g"
    },
    {
        category:"현대",
        age:"20세기 후반 - 현재",
        img:"2010_thesocialnetwork.jpg",
        title:"소셜 네트워크",
        englishTitle:"The Social Network",
        release:[2010,12],
        country:["미국"],
        type:["영화"],
        genre:["드라마"],
        playTime:["2시간 1분"],
        creater:["데이비드 핀처","애런 소킨","다나 브루네티","신 채핀","마이클 드루카","스콧 루딘"],
        synopsis:"1980년대 초 부산 빽도 없고, 돈도 없고, 가방끈도 짧은 세무 변호사 송우석(송강호) 부동산 등기부터 세금 자문까지 남들이 뭐라든 탁월한 사업수완으로 승승장구하며 부산에서 제일 잘나가고 돈 잘 버는 변호사로 이름을 날린다. 10대 건설 기업의 스카우트 제의까지 받으며 전국구 변호사 데뷔를 코 앞에 둔 송변. 하지만 우연히 7년 전 밥값 신세를 지며 정을 쌓은 국밥집 아들 진우(임시완)가 뜻하지 않은 사건에 휘말려 재판을 앞두고 있다는 소식을 듣는다. 국밥집 아줌마 순애(김영애)의 간절한 부탁을 외면할 수 없어 구치소 면회만이라도 도와주겠다고 나선 송변. 하지만 그곳에서 마주한 진우의 믿지 못할 모습에 충격을 받은 송변은 모두가 회피하기 바빴던 사건의 변호를 맡기로 결심하는데...",
        cast:["제시 아이젠버그", "앤드류 가필드", "저스틴 팀버레이크", "아미 해머"],
        background:"미국",
        adaptation:"실제 역사에 가까운",
        keyword:["원작이 존재","마크 주커버그"],
        src:"lB95KLmpLR4"
    }
]
    
    
    export default contents_all